import * as yup from "yup";
import i18n from "../../../../i18n";

const requiredMessage = () => i18n.t("validation.required", {ns: "common"});
const numberMoreThan0Message = () => i18n.t("validation.numberGreaterThanZero", {ns: "common"});

const cutOffOptionsValidations = yup.object().shape({
    options: yup.object().shape({
        cutOff: yup.object().shape({
            isActive: yup.bool(),
            cutOffTime: yup.object().shape({
                hour: yup.number(),
                minute: yup.number()
            }),
            pickupTime: yup.number().when("isActive", {
                is: true,
                then: yup
                    .number()
                    .required(requiredMessage)
                    .positive(numberMoreThan0Message)
                    .integer()
            }),
            handOverTime: yup.number().when("isActive", {
                is: true,
                then: yup
                    .number()
                    .required(requiredMessage)
                    .positive(numberMoreThan0Message)
                    .integer()
            }),
            maxOrder: yup.number().when("isActive", {
                is: true,
                then: yup
                    .number()
                    .required(requiredMessage)
                    .positive(numberMoreThan0Message)
                    .integer()
            })
        })
    })
});

export default cutOffOptionsValidations;
